import React, { Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import Layout from "./Layout";
import { AppState } from "./reducers";
import Auth from "./services/Auth/Auth";
import Spinner from "./components/Spinner";
import DriverDocuments from "./views/DriverDocumnets";
import { IconButton, Snackbar, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { setDocumentsNotification } from "./actions/valueDriverActions";

// import { useTranslation } from "react-i18next";

const Home = React.lazy(() => import("./views/Home/home"));
const Performance = React.lazy(() => import("./views/Performance"));
const Drivers = React.lazy(() => import("./views/Drivers"));
const Vehicles = React.lazy(() => import("./views/Vehicles"));
const Trips = React.lazy(() => import("./views/Trips"));
const FormView = React.lazy(() => import("./views/FormView"));
const Profil = React.lazy(() => import("./views/FormView"));
const Earnings = React.lazy(() => import("./views/Revenues"));
const Payments = React.lazy(() => import("./views/Paiements"));
const Error = React.lazy(() => import("./views/404/404"));
const Maps = React.lazy(() => import("./views/Maps"));

function App() {
  const { isConnected } = useSelector((state: AppState) => state.account);

  const { intl } = useSelector((state: AppState) => state.intl);

  const dispatch = useDispatch();

  const { documentNotification } = useSelector(
    (state: AppState) => state.driver
  );

  const ProtectedRoute = ({ children }) => {
    if (!isConnected) {
      return <Navigate to="/" replace />;
    }
    return children;
  };

  const IsLoginRoute = ({ children }) => {
    if (isConnected) {
      return <Navigate to="/performance" replace />;
    }
    return children;
  };

  const onNotificationClose = () => {
    dispatch(setDocumentsNotification(""));
  };
  return (
    <div className="App">
      <div dir={intl === "ar" ? "rtl" : "ltr"}>
        <BrowserRouter>
          <Auth>
            <Layout>
              <Suspense fallback={isConnected && <Spinner />}>
                <Snackbar
                  open={!!documentNotification}
                  autoHideDuration={6000}
                  onClose={onNotificationClose}
                  sx={{
                    maxWidth: 512,
                    textAlign: "start",
                    bgcolor: "#fff",
                    py: "12px",
                    px: "8px",
                    borderRadius: "12px",
                  }}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <Stack gap={1}>
                    <CheckCircleOutlineOutlinedIcon
                      sx={{
                        padding: "8px",
                        borderRadius: "12px",
                        bgcolor: "#EAFCE6",
                        color: "#4CB95F",
                      }}
                    />
                    <Typography variant="body1" fontSize={14} fontWeight={700}>
                      {documentNotification}
                    </Typography>

                    <IconButton size="small" onClick={onNotificationClose}>
                      <CloseIcon sx={{ color: "#666" }} />
                    </IconButton>
                  </Stack>
                </Snackbar>
                <Routes>
                  <Route
                    path="/"
                    element={
                      <IsLoginRoute>
                        <Home />
                      </IsLoginRoute>
                    }
                  />
                  <Route
                    path="/performance"
                    element={
                      <ProtectedRoute>
                        <Performance />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/chauffeurs"
                    element={
                      <ProtectedRoute>
                        <Drivers />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/vehicules"
                    element={
                      <ProtectedRoute>
                        <Vehicles />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/trips"
                    element={
                      <ProtectedRoute>
                        <Trips />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/map"
                    element={
                      <ProtectedRoute>
                        <Maps />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/:type/form/:id?"
                    element={
                      <ProtectedRoute>
                        <FormView />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/driver/:driverId"
                    element={
                      <ProtectedRoute>
                        <Profil />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/driver-documents/:driverId"
                    element={
                      <ProtectedRoute>
                        <DriverDocuments />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/revenues"
                    element={
                      <ProtectedRoute>
                        <Earnings />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/paiements/:cycle?/:idPay?"
                    element={
                      <ProtectedRoute>
                        <Payments />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="*" element={<Error />} />
                </Routes>
              </Suspense>
            </Layout>
          </Auth>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
